export interface BadgeMeta {
  color: string;
  emoji: string;
  label: string;
  description: string;
}

/** Maps badge key → visual metadata. All display logic lives here. */
export const BADGE_META: Record<string, BadgeMeta> = {
  // Volume track
  'volume-bronze':   { color: 'orange',  emoji: '🥉', label: 'Bronze Critic',    description: 'Submitted 5 reviews' },
  'volume-silver':   { color: 'gray',    emoji: '🥈', label: 'Silver Critic',    description: 'Submitted 25 reviews' },
  'volume-gold':     { color: 'yellow',  emoji: '🥇', label: 'Gold Critic',      description: 'Submitted 50 reviews' },
  'volume-platinum': { color: 'cyan',    emoji: '💿', label: 'Platinum Critic',  description: 'Submitted 100 reviews' },
  'volume-diamond':  { color: 'blue',    emoji: '💠', label: 'Diamond Critic',   description: 'Submitted 250 reviews' },
  'volume-obsidian': { color: 'dark',    emoji: '⬛', label: 'Obsidian Critic',  description: 'Submitted 500 reviews' },

  // Quality track
  'quality-trusted': { color: 'teal',   emoji: '✅', label: 'Trusted Reviewer', description: '75%+ helpful votes with at least 10 voted reviews' },
  'quality-expert':  { color: 'indigo', emoji: '⭐', label: 'Expert Reviewer',  description: '85%+ helpful votes with at least 25 voted reviews' },
  'quality-elite':   { color: 'violet', emoji: '🌟', label: 'Elite Reviewer',   description: '90%+ helpful votes with at least 50 voted reviews' },
};

export function getBadgeMeta(key: string): BadgeMeta {
  return BADGE_META[key] ?? { color: 'gray', emoji: '🏅', label: key };
}
